import cx from 'classnames';
import { useState } from 'react';
import { Button, ButtonVariants } from '@components/button/Button';
import { errorToast } from '@components/toasts/Toasts';
import { reportAppError } from '@shared/reportAppError';
import { useUpdateGuestVipTier } from 'restaurantAdmin/hooks/useGuestVipTier';
import type { GuestVipTierAssignment } from 'restaurantAdmin/guestBook/apiHelpers';
import {
  GuestVipTierCombobox,
  type VipTierOption,
} from '../GuestVipTierCombobox/GuestVipTierCombobox';
import styles from './GuestVipTierEditForm.scss';

interface GuestVipTierEditFormProps {
  guestId: string;
  guestVipTier: GuestVipTierAssignment;
  onComplete: () => void;
}

export const GuestVipTierEditForm = ({
  guestId,
  guestVipTier,
  onComplete,
}: GuestVipTierEditFormProps) => {
  const { mutateAsync: saveGuestVipTier, isPending } =
    useUpdateGuestVipTier(guestId);
  const [selectedTier, setSelectedTier] = useState<VipTierOption | null>(
    guestVipTier.vipTier
      ? { id: guestVipTier.vipTier.id, name: guestVipTier.vipTier.name }
      : null,
  );

  const handleOnSave = async () => {
    try {
      await saveGuestVipTier(selectedTier?.id ?? null);
      onComplete();
    } catch (error) {
      errorToast({ message: 'Failed to update guest VIP tier' });
      reportAppError(error);
    }
  };

  return (
    <div className={styles.container}>
      <GuestVipTierCombobox onChange={setSelectedTier} value={selectedTier} />
      <div className={styles.actions}>
        <Button
          className={cx(styles.btn, styles.secondaryBtn)}
          isDisabled={isPending}
          label="Discard"
          onClick={onComplete}
          variant={ButtonVariants.DefaultWhite}
        />
        <Button
          className={styles.btn}
          isDisabled={isPending}
          label="Save"
          onClick={handleOnSave}
          variant={ButtonVariants.Primary}
        />
      </div>
    </div>
  );
};
